<template>
    <fup-input v-bind="$attrs"
               :value="value"
               :number="true"
               type="number"
               @input="input"
               v-on="$listeners">
    </fup-input>
</template>

<script>
    const REGEXP_NUMBER = /^-?(?:\d+|\d+\.\d+|\.\d+)(?:[eE][-+]?\d+)?$/;

    export default {
        name: 'fup-number-input',
        props: {
            value: {
                type: [String, Number],
                default: 0
            },
        },
        methods: {
            input(value) {
                this.$emit('input', value);
            },
        }
    };
</script>